import styled from "styled-components"
import { Link } from "react-router-dom"

import { formatPriceByLocale } from "utils/utils"

import SVGIcon from "components/modules/common/SVGIcon"

export default function MotibellItem({
  motibellNo,
  status,
  title,
  rewardTxt,
  currCapacity,
  maxCapacity,
  viewCnt,
  isLanding,
  isJoin,
}) {
  return (
    <LinkBlock
      to={!isJoin && isLanding ? `/motibell/${motibellNo}/landing` : `/motibell/${motibellNo}`}
    >
      <MotibellStatusBlock>
        <MotibellStatus bgColor={status.bgColor}>{status.text}</MotibellStatus>
      </MotibellStatusBlock>
      <MotibellTitleBlock>
        <MotibellTitle>{title}</MotibellTitle>
        <RewardBlock>
          <RewartTxt isActive={status.isActive}>{rewardTxt}</RewartTxt>
          <RightArrowBlock isActive={status.isActive}>
            <SVGIcon name="arrow" />
          </RightArrowBlock>
        </RewardBlock>
      </MotibellTitleBlock>
      <StatisticsBlock>
        <CapacityBlock>
          <PeopleIconBlock>
            <SVGIcon name="people" />
          </PeopleIconBlock>
          <CapacityCount>
            {formatPriceByLocale("ko", currCapacity)}
            {maxCapacity && ` / ${formatPriceByLocale("ko", maxCapacity)}`}
          </CapacityCount>
        </CapacityBlock>
        <CapacityBlock>
          <PeopleIconBlock>
            <SVGIcon name="eyeFill" />
          </PeopleIconBlock>
          <CapacityCount>{viewCnt}</CapacityCount>
        </CapacityBlock>
      </StatisticsBlock>
    </LinkBlock>
  )
}

const LinkBlock = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f7f7f7;
  border-radius: 0.9rem;
  padding-top: calc(100vw * (11 / 375));
  padding-bottom: calc(100vw * (13 / 375));
  padding-right: calc(100vw * (18 / 375));
  padding-left: calc(100vw * (18 / 375));

  & + & {
    margin-top: calc(100vw * (16 / 375));
  }
`

const MotibellStatusBlock = styled.div`
  display: flex;
  justify-content: flex-start;
`

const MotibellStatus = styled.span`
  color: #fff;
  border-radius: calc(100vw * (5 / 375));
  font-size: calc(100vw * (11 / 375));
  font-weight: 700;
  line-height: calc(100vw * (22 / 375));
  padding: 0 calc(100vw * (6 / 375));

  background-color: ${({ bgColor }) => bgColor};
`

const MotibellTitleBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const MotibellTitle = styled.span`
  display: -webkit-box;
  font-size: calc(100vw * (16 / 375));
  font-weight: 600;
  line-height: calc(100vw * (23 / 375));
  color: #121212;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  word-break: break-all;
  width: calc(100vw * (164 / 375));
  margin: calc(100vw * (5 / 375)) 0;
  overflow: hidden;
`

const RewardBlock = styled.div`
  display: flex;
  align-items: center;
`

const RewartTxt = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (26 / 375));
  color: ${({ isActive }) => (isActive ? "#ff944b" : "#c4c4c4")};
`

const RightArrowBlock = styled.div`
  width: calc(100vw * (5 / 375));
  height: calc(100vw * (8 / 375));
  margin-left: calc(100vw * (6 / 375));

  svg {
    color: ${({ isActive }) => (isActive ? "#ff944b" : "#c4c4c4")};
  }
`

const StatisticsBlock = styled.div`
  display: flex;
`

const CapacityBlock = styled.div`
  display: flex;
  align-items: center;
  & + & {
    margin-left: 1rem;
  }
`

const PeopleIconBlock = styled.div`
  width: calc(100vw * (13 / 375));
  height: calc(100vw * (13 / 375));
  margin-right: calc(100vw * (4 / 375));

  svg {
    color: #a0a0a0;
  }
`

const CapacityCount = styled.span`
  font-size: calc(100vw * (11 / 375));
  font-weight: 500;
  color: #a0a0a0;
`

const ViewBlock = styled.div``
